/**
 * Style keys that apply only in dark mode, for `sx` objects in Server Components (which can't pass
 * `theme.applyStyles`). Matches the theme's `colorSchemeSelector: "class"` (MUI puts `dark` on <html>).
 */
export const DARK = "*:where(.dark) &";
